document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".slider__items");
  const slides = Array.from(slider.children);
  let currentSlide = 0;
  let startX,
    moveX,
    isTouching = false;

  function updateSlider() {
    let visibleSlides = getVisibleSlidesCount();
    const slideWidth = slider.clientWidth / visibleSlides;
    slider.style.transition = "transform 0.5s ease";
    slider.style.transform = `translateX(${-currentSlide * slideWidth}px)`;

    // Disable buttons on the edges
    const isPrevDisabled = currentSlide === 0;
    const isNextDisabled = currentSlide === slides.length - visibleSlides;
    document.querySelector(".slider__btn--prev").disabled = isPrevDisabled;
    document.querySelector(".slider__btn--next").disabled = isNextDisabled;

  }

  function getVisibleSlidesCount() {
    const screenWidth = window.innerWidth;
    if (screenWidth < 480) {
      return 2; // Mobile devices
    } else if (screenWidth < 1279) {
      return 4; // Tablet devices
    } else {
      return 6; // Desktop
    }
  }

  function handleTouchStart(event) {
    startX = event.touches[0].clientX;
    isTouching = true;
  }

  function handleTouchMove(event) {
    if (!isTouching) return;
    moveX = event.touches[0].clientX;
    const diffX = moveX - startX;

    if (Math.abs(diffX) > 10) {
      event.preventDefault();
    }
  }

  function handleTouchEnd() {
    if (!isTouching) return;
    const threshold = 50; // Minimum distance (px) to trigger a slide move
    const diffX = moveX - startX;
    console.log("Touch end - diffX:", diffX);

    if (diffX > threshold && currentSlide > 0) {
      currentSlide -= 1;
    } else if (
      diffX < -threshold &&
      currentSlide < slides.length - getVisibleSlidesCount()
    ) {
      currentSlide += 1;
    }

    updateSlider();
    isTouching = false; // Reset the touching flag
  }

  window.moveSlide = function (direction) {
    const maxSlideIndex = slides.length - getVisibleSlidesCount();
    if (direction === -1 && currentSlide > 0) {
      currentSlide -= 1;
    } else if (direction === 1 && currentSlide < maxSlideIndex) {
      currentSlide += 1;
    }
    updateSlider();
  };
  // Touch event listeners
  slider.addEventListener("touchstart", handleTouchStart, { passive: false });
  slider.addEventListener("touchmove", handleTouchMove, { passive: false });
  slider.addEventListener("touchend", handleTouchEnd);

  window.addEventListener("resize", () => {
    currentSlide = 0;
    updateSlider();
  });

  window.addEventListener("orientationchange", () => {
    currentSlide = 0;
    updateSlider();
  });

  function toggleButtonVisibility(button, shouldHide, hideClass) {
    if (shouldHide) {
      button.classList.add(hideClass);
    } else {
      button.classList.remove(hideClass);
    }
  }
  function updateButtonVisibility() {
    const prevButton = document.querySelector(".slider__btn--prev");
    const nextButton = document.querySelector(".slider__btn--next");

    toggleButtonVisibility(
      prevButton,
      window.hideOnDesktop,
      "slider__btn--desktop-hide"
    );
    toggleButtonVisibility(
      nextButton,
      window.hideOnDesktop,
      "slider__btn--desktop-hide"
    );

    toggleButtonVisibility(
      prevButton,
      window.hideOnTablet,
      "slider__btn--tablet-hide"
    );
    toggleButtonVisibility(
      nextButton,
      window.hideOnTablet,
      "slider__btn--tablet-hide"
    );

    toggleButtonVisibility(
      prevButton,
      window.hideOnMobile,
      "slider__btn--mobile-hide"
    );
    toggleButtonVisibility(
      nextButton,
      window.hideOnMobile,
      "slider__btn--mobile-hide"
    );
  }

  updateButtonVisibility();
  updateSlider();
});
